import gql from 'graphql-tag'

export const productSelectorData = gql`
  query psGetNextQuestion(
    $questionId: Int
    $questionnaireCode: String!
    $answerId: Int
  ) {
    psGetNextQuestion(
      question_id: $questionId,
      questionnaire_code: $questionnaireCode,
      answer_id: $answerId
    ) {
      total_questions
      question {
        title
        id
        row_id
        type
        notes
        limit
        options {
          label
          value
          image
          child_options {
            label
            value
          }
        }
      }
      result
    }
  }
`

export const saveCustomerAnswers = gql`
  mutation psSaveCustomerQuestionnaire(
    $answers: [PsAnswerInput]
    $questionnaireCode: String!
    $customerEmail: String
  ) {
    psSaveCustomerQuestionnaire (
      answers: $answers,
      questionnaire_code: $questionnaireCode,
      email: $customerEmail
    ) {
      message
      result {
        sku
        name
        url_key
        primary_bladder_leakage
        manufacturer
        uses_by_day
        thumbnail
        product {
          sku
          id
          name
          url_key
          image {
            label
            url
          }
          media_gallery_entries {
            disabled
            file
            id
            media_type
            position
          }
          visiture_custom_attributes
          price_range {
            maximum_price {
              final_price {
                value
              }
            }
          }
        }
      }
    }
  }
`

export const getCustomerRecommendation = gql`
  query psGetRecommendation(
    $customerEmail: String!
    $questionnaireCode: String!
  ){
    psGetRecommendation (input: {
      customer_email: $customerEmail,
      questionnaire_code: $questionnaireCode
    }) {
      products {
        name
        learn_more
        view_related_products
      }
    }
  }
`
